import { render, staticRenderFns } from "./Bandemail.vue?vue&type=template&id=35663c5c&scoped=true"
import script from "./Bandemail.vue?vue&type=script&lang=js"
export * from "./Bandemail.vue?vue&type=script&lang=js"
import style0 from "./Bandemail.vue?vue&type=style&index=0&id=35663c5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35663c5c",
  null
  
)

export default component.exports